import { applyTimezone } from './apply-timezone';

export const SlotRanges = {
	applyTimezone,
};
